import {Validation} from "@/shared/graphql/types";

export {default as FormItem} from './FormItem.vue'
export {default as FormLabel} from './FormLabel.vue'
export {default as FormControl} from './FormControl.vue'
export {default as FormMessage} from './FormMessage.vue'
export {default as FormDescription} from './FormDescription.vue'
export {default as Form} from './Form.vue'
import type {ObjectSchema} from 'yup'
import {InjectionKey, Ref} from 'vue'

export interface FormInstance {
    validate: () => Promise<boolean>
    submit: () => Promise<void>
}

export type FormValidationError = {
    label: string;
    source: FormValidationSource
}

export enum FormValidationSource {
    CLIENT,
    SERVER
}

export interface FormContext {
    validation: ObjectSchema<any>;
    errors: Ref<Record<string, FormValidationError>>;  // Now uses ValidationError type
    value: Record<string, any>;  // Renamed from values to value, represents the form data object (like user)
}

export const FormContextSymbol = Symbol('FormContext') as InjectionKey<FormContext>

export function validationToErrors(validation: Validation) : object {
    const parsedErrors = {};
    validation.fieldErrors.forEach((error) => {
        parsedErrors[error.path] = error.message;
    });
    return parsedErrors;
}